import { lazy } from "react";
import MainLayout from "layout/MainLayout";
import Loadable from "ui-component/Loadable";
const Error = Loadable(lazy(() => import("views/pages/maintenance/Error")));
const PrivacyPolicy = Loadable(lazy(() => import("views/pages/landing/PrivacyPolicy")));

const GuestRoutes = {
    path: "/",
    element: (
       
        <MainLayout /> 
          
    ),
    children: [
        { path: "*", element: <Error /> },
        {path:"/privacy-policy",element:<PrivacyPolicy/>}
      

    ]
}
    export default GuestRoutes